import {LeasingRateMatrixCell} from '@dms/api/vehicle';

/**
 * Orders cells the way the leasing matrix reads: the shortest term first, then the lowest annual
 * mileage. The financing counterpart is `compareFinancingCells`.
 */
export function compareLeasingCells(left: LeasingRateMatrixCell, right: LeasingRateMatrixCell) {
  return left.term - right.term || left.annualMileage - right.annualMileage;
}
